<template>
  <div>
    <v-app-bar
      :value="showHeader"
      app clipped-left clipped-right
      :dark="!isChristmas" :light="isChristmas" flat :color="appBarColor"
    >
    <!-- Let it snow -->
      <template v-slot:img v-if="isChristmas">
        <div class="wrapper">
          <div class="snow layer1 a"></div>
          <div class="snow layer1"></div>
          <div class="snow layer2 a"></div>
          <div class="snow layer2"></div>
          <div class="snow layer3 a"></div>
          <div class="snow layer3"></div>
        </div>
      </template>
    <!-- End -->

      <router-link to="/">
        <v-img src="@/assets/logo_header.png" width="220" class="mr-4"/>
      </router-link>
      <v-chip dark v-if="modeNoProd" color="warning" style="flex:none">{{ modeNoProd }}</v-chip>
      <v-btn v-if="isChristmas" icon @click="onPlayClick"><v-icon>{{ isPlaying ? 'mdi-music-note' : 'mdi-music-note-off' }}</v-icon></v-btn>
      <v-tabs right optional>
        <v-tab disabled/>
        <v-menu
          bottom offset-y
          nudge-right="-225"
          nudge-top="2"
          transition="slide-x-transition"
          v-for="item in activeItems"
          :key="item.path"
          :disabled="!item.children"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-tab v-bind="attrs" v-on="on" :to="!item.children ? item.path : ''">
              <v-badge :value="item.name === 'Customer' && updatedCustomerCount" :content="updatedCustomerCount">
                {{ item.text || item.name || item.path }}
              </v-badge>
            </v-tab>
          </template>
          <v-tabs height="64" optional>
            <v-tab
              v-for="(child, index) in item.children"
              :key="index"
              :to="{ name: child.name }"
            >
              {{ child.text || child.name || child.path }}
            </v-tab>
          </v-tabs>
        </v-menu>
      </v-tabs>
      <v-avatar color="#BC9B6A">
        <span class="white--text text-h5" :title="fullname">{{ accountInitials() }}</span>
      </v-avatar>
      <v-btn icon @click="switchDialogLogout" class="ml-2">
        <v-icon title="Déconnexion">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-dialog v-model="dialogLogout" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Déconnexion
        </v-card-title>

        <v-card-text class="pt-4"
          >Êtes-vous sûr de vouloir vous déconnecter ?</v-card-text
        >

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="switchDialogLogout()">
            Annuler
          </v-btn>
          <v-btn text color="error" @click="logout()">
            Accepter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import store from '@/store'
import routes from '@/router/routes'
import christmasSound from '@/assets/audio/christmas_sound.mp3'
import { customerApi } from '@/api/customer/customer'

export default Vue.extend({
  name: 'ArqanaHeader',

  data: () => ({
    dialogLogout: false,
    authState: store.state,
    delay: undefined as ReturnType<typeof setTimeout> | undefined,
    mini: true,
    tab: null,
    updatedCustomerCount: 0,

    christmasSound: undefined as HTMLAudioElement|undefined,
    isPlaying: false,
  }),
  methods: {
    switchDialogLogout() {
      this.dialogLogout = !this.dialogLogout
    },
    logout() {
      store.logout()
      this.$router.push('/login')
      this.dialogLogout = false
    },
    extend() {
      this.delay = setTimeout(() => {
        this.mini = false
      }, 250)
    },
    collapse() {
      clearTimeout(this.delay)
      this.mini = true
    },
    accountInitials() : string {
      if (!this.fullname) {
        return ''
      } else {
        const name = this.fullname.split(' ')
        return `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ''}`
      }
    },
    onPlayClick() {
      if (this.isPlaying) {
        // eslint-disable-next-line no-unused-expressions
        this.christmasSound?.pause()
      } else {
        // eslint-disable-next-line no-unused-expressions
        this.christmasSound?.play()
      }
      this.isPlaying = !this.isPlaying
    },
  },
  computed: {
    activeItems() {
      return routes.filter(route => {
        if (typeof route.display === 'function') {
          return route.display()
        } else {
          return route.display !== false
        }
      })
    },
    showHeader() {
      return this.$route.name !== 'Login'
    },
    fullname(): string | undefined {
      if (store.state.userInfo !== undefined) {
        return store.state.userInfo.fullname ?? store.state.userInfo.username
      }
      return undefined
    },
    isChristmas(): boolean {
      const date = new Date()
      return date.getMonth() === 11 && date.getDate() >= 20 && date.getDate() <= 30
    },
    appBarColor(): string {
      if (this.isChristmas) {
        return 'info lighten-1'
      } else {
        return 'primary darken-1'
      }
    },
    modeNoProd() {
      if (process.env.VUE_APP_MODE === 'prod') {
        return ''
      } else {
        return process.env.VUE_APP_MODE?.toUpperCase()
      }
    },
  },
  async mounted() {
    if (this.isChristmas) {
      this.christmasSound = new Audio(christmasSound)
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.christmasSound!.currentTime = 56 // magic
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.christmasSound!.loop = true
    }
    this.updatedCustomerCount = await customerApi.getUpdatedCustomerCount()
    setInterval(async () => {
      this.updatedCustomerCount = await customerApi.getUpdatedCustomerCount()
    }, 1000 * 60 * 5)
  },
})
</script>

<style lang="scss" scoped>
  .wrapper {
    width:100vw;
    height:100px;
    //background: radial-gradient(farthest-corner at 30vw 20vh,#7397a1 1%,#3f2c41 100%);
    opacity: 0.4;
  }
  $s1:"";
  $s2:"";
  $s3:"";
  @for $i from 1 through 300 {
    $s1: $s1 + random(1000)*0.1vw + " " + random(1000)*0.1vh + " " + 0 + " " + random(50)*-0.01rem + #fff;
    $s2: $s2 + random(1000)*0.1vw + " " + random(1000)*0.1vh + " " + 0 + " " + random(50)*-0.01rem + #fff;
    $s3: $s3 + random(1000)*0.1vw + " " + random(1000)*0.1vh + " " + 0 + " " + random(50)*-0.01rem + #fff;
    @if $i < 300 {
        $s1: $s1 + ",";
        $s2: $s2 + ",";
        $s3: $s3 + ",";
    }
  }
  .snow {
    border-radius: 50%;
    opacity: 0.8;
    position: absolute;
    top:-100vh;
    animation-name: fall;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
  .layer1 {
    width: 1.5rem;
    height: 1.5rem;
    filter:blur(1.5px);
    box-shadow: #{$s1};
    animation-duration: 6s;
  }
  .layer1.a {
    animation-delay: -3s;
  }
  .layer2 {
    width: 1.2rem;
    height: 1.2rem;
    filter:blur(3px);
    box-shadow: #{$s2};
    animation-duration: 10s;
  }
  .layer2.a {
    animation-delay: -4s;
  }
  .layer3 {
    width: 0.8rem;
    height: 0.8rem;
    filter:blur(6px);
    box-shadow: #{$s3};
    animation-duration: 15s;
  }
  .layer3.a {
    animation-delay: -5s;
  }
  @keyframes fall {
    100% {transform: translateY(200vh); }
  }
</style>
